import { get, set, findIndex, size, reject, omit } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import {
  fetchGuestForView,
  updateGuest,
  deleteHouseholdMember,
  deleteGuest
} from '../../../sagas/routines';
import {
  clearGuestView,
  guestViewAddMember,
  guestViewUpdateMember
} from '../../../actions/routes/view';

const initialState = {
  data: null,
  fetching: false,
  fetched: false,
  deletingMember: false,
  deletedMember: false,
  deletingGuest: false,
  deletedGuest: false
};

const fetchGuestForViewHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('data', response, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

const updateGuestForViewHandler = routine => ({
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('data', response, state)
});

const clearGuestViewHandler = action => ({
  [action.toString()]: () => initialState
});

const addGuestMemberHandler = action => ({
  [action.toString()]: (state, { payload: member }) => {
    const members = get('data.othersHousehold', state) || [];
    const othersHousehold = [...members, member];
    const membersCount = size(othersHousehold) + 1;
    const householdTotal = get('data.household_total', state);

    const data = {
      ...state.data,
      othersHousehold,
      household_total:
        householdTotal < membersCount ? membersCount : householdTotal
    };
    return set('data', data, state);
  }
});

const updateGuestMemberHandler = action => ({
  [action.toString()]: (state, { payload: member }) => {
    const members = get('data.othersHousehold', state);
    const key = findIndex({ id: member.id }, members);
    return set(`data.othersHousehold.${key}`, member, state);
  }
});

const deleteGuestMemberHandler = routine => ({
  [routine.TRIGGER]: state => ({
    ...state,
    deletingMember: true,
    deletedMember: false
  }),
  [routine.SUCCESS]: (state, { payload: { id } }) => {
    const { data } = state;
    const othersHousehold = reject({ id }, data.othersHousehold);
    const householdTotal = data.household_total - 1;
    return {
      ...state,
      data: { ...data, othersHousehold, household_total: householdTotal }
    };
  },
  [routine.FULFILL]: state => ({
    ...state,
    deletingMember: false,
    deletedMember: true
  })
});

const deleteGuestHandler = routine => ({
  [routine.TRIGGER]: state => ({
    ...state,
    deletingGuest: true,
    deletedGuest: false
  }),
  [routine.SUCCESS]: (state, { payload: { id } }) => {
    const { data } = state;
    return {
      ...state,
      data: omit(id, data)
    };
  },
  [routine.FULFILL]: state => ({
    ...state,
    deletingGuest: false,
    deletedGuest: true
  })
});

export default createReducer(initialState, {
  ...fetchGuestForViewHandler(fetchGuestForView),
  ...updateGuestForViewHandler(updateGuest),
  ...addGuestMemberHandler(guestViewAddMember),
  ...updateGuestMemberHandler(guestViewUpdateMember),
  ...deleteGuestMemberHandler(deleteHouseholdMember),
  ...clearGuestViewHandler(clearGuestView),
  ...deleteGuestHandler(deleteGuest)
});
